'use client';

import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { tv } from 'tailwind-variants';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Typography } from '@/components/ui/typography/typography.component';
import { Button } from '@/components/ui/button/button.component';
import { Card } from '@/components/ui/card.component';
import { MostSearchedResult } from '@/types/most-search-type';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { ContentContainer } from '@/components/ui/content-container.component';

const style = tv({
  slots: {
    buttonProcedure:
      'flex flex-row items-start justify-between gap-0 h-fit py-4 w-full xl:pl-5 xl:pr-4',
  },
  variants: {
    isTop: {
      true: {
        buttonProcedure: 'pt-0',
      },
    },
    isBottom: {
      true: {
        buttonProcedure: 'pb-0',
      },
    },
  },
});

interface ProceduresCardProps {
  procedures?: MostSearchedResult[];
  onSeeMore?: () => void;
  goToSearchProcedureSchedules: (procedure: MostSearchedResult) => void;
}

export function ProceduresCard({
  procedures,
  onSeeMore,
  goToSearchProcedureSchedules,
}: ProceduresCardProps) {
  const { buttonProcedure } = style();

  return (
    <Card
      data-testid={DataTestIdEnum.CITY_MOST_SEARCHED_SECTION_CARD}
      className="flex flex-col justify-end items-center w-full px-0 rounded-none border-x-0 xl:border-x xl:rounded-xl h-fit"
    >
      {procedures?.map((procedure, index) => (
        <div
          key={`key-most-searched-procedures-${procedure.type}${procedure.id}`}
          className="flex flex-col justify-end items-center w-full"
        >
          <ContentContainer>
            <Button
              variant="text"
              data-testid={DataTestIdEnum.HOME_MOST_SEARCHED_ITEM}
              onClick={() => goToSearchProcedureSchedules(procedure)}
            >
              <div
                className={buttonProcedure({
                  isTop: index === 0,
                  isBottom: index === procedures.length - 1 && !onSeeMore,
                })}
              >
                <Typography className="text-green-500 justify-start text-nowrap truncate font-bold text-start line-clamp-2">
                  {formatToTitleCase(procedure.displayName)}
                </Typography>
              </div>
            </Button>
          </ContentContainer>
          {index != procedures.length - 1 && <hr className="w-full -mx-11" />}
        </div>
      ))}
      <>
        {onSeeMore && (
          <>
            {!!procedures?.length && <hr className="w-full -mx-11" />}
            <ContentContainer>
              <Button
                variant="text"
                className={buttonProcedure({
                  className: 'justify-start font-bold',
                  isBottom: true,
                  isTop: Number(procedures?.length) === 0,
                })}
                startIconClassName="mt-[2px] mr-2"
                onClick={onSeeMore}
                startIcon={faArrowRight}
              >
                Ver mais
              </Button>
            </ContentContainer>
          </>
        )}
      </>
    </Card>
  );
}
